import { ProjectSubmitWarningReason, QuoteStatus } from 'quotes/enums';
import { ICustomerQuote, IProjectSubmitWarning } from 'quotes/types';

import { SubmitOrderBlockReason } from './enums';

type SubmitBlockQuote = Pick<ICustomerQuote, 'status' | 'externalOrderNumber'>;

// Mirrors the BE refusal in DdpOrderService: the integration is CREATE-only, so an order the
// external system already knows must never be re-submitted, and one still being processed
// must not race itself. Check order is load-bearing: a known external order number is the
// strongest signal, then a timed-out submit (the order may or may not exist there), then a
// submit still in progress.
export const getSubmitOrderBlockReason = (
  quote?: SubmitBlockQuote | null
): SubmitOrderBlockReason | null => {
  if (quote?.externalOrderNumber) {
    return SubmitOrderBlockReason.ALREADY_SUBMITTED;
  }

  if (QuoteStatus.ORDER_SUBMISSION_TIMED_OUT === quote?.status) {
    return SubmitOrderBlockReason.SUBMISSION_TIMED_OUT;
  }

  if (QuoteStatus.ORDER_ORDERING === quote?.status) {
    return SubmitOrderBlockReason.ORDERING;
  }

  return null;
};

// A credit hold lets the submit through but parks the order, so the user confirms it first.
export const isCreditHoldConfirmationRequired = (
  projectSubmitWarning?: IProjectSubmitWarning | null
): boolean => ProjectSubmitWarningReason.CREDIT_HOLD === projectSubmitWarning?.reason;
